<template>
    <button class="ds-auth-button-primary">
        <slot></slot>
    </button>
</template>
